import React from "react";
import { quotesRoutes } from "./features/Quotes/constant";
export const GlobleLoaderContext = React.createContext((loader) => { });
export const createHash = async (str) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
        .map((byte) => byte.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
};
export const clearStorageOnLogout = () => {
    localStorage.removeItem("acc_data");
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("lgnSrc");
    localStorage.removeItem("guest_acc_data");
    localStorage.removeItem("consentList");
    localStorage.removeItem("cnsList");
    localStorage.removeItem("accountCode");
};
export const reports = "/newreports/";
export var EReportRoutes;
(function (EReportRoutes) {
    EReportRoutes["dashboard"] = "dashboard";
    EReportRoutes["holding"] = "holding";
    EReportRoutes["positions"] = "positions";
    EReportRoutes["positionSqrOff"] = "positionSqrOff";
    EReportRoutes["orderbook"] = "orderbook";
    EReportRoutes["profitandloss"] = "profitandloss";
    EReportRoutes["downloadReport"] = "download-report";
    EReportRoutes["tax"] = "tax";
    EReportRoutes["contractNotes"] = "contract-notes-statements";
    EReportRoutes["subscriptionHistory"] = "subscription-history";
    EReportRoutes["marginReport"] = "margin-report";
    EReportRoutes["ledgerReport"] = "ledger-report";
    EReportRoutes["dpBills"] = "dp-bills";
    EReportRoutes["dpInterest"] = "dp-interest";
    EReportRoutes["transactionHistory"] = "transaction-history";
    EReportRoutes["dpTransaction"] = "dp-transaction";
})(EReportRoutes || (EReportRoutes = {}));
// paths
export const forBetalive = true;
const opClientReportPaths = {
    [EReportRoutes.dpTransaction]: reports + EReportRoutes.dpTransaction,
    /********************** tax =dev-in-progress  &  dashboard=upcoming  ******************/
    [EReportRoutes.dashboard]: reports + EReportRoutes.dashboard,
    [EReportRoutes.tax]: reports + EReportRoutes.tax,
    /*************************** common download & email for new reports*******************/
    [EReportRoutes.downloadReport]: reports + EReportRoutes.downloadReport,
    /***************************paths to show other reports independently  after tax, position and dashboard goes beta live******************/
    [EReportRoutes.contractNotes]: reports + EReportRoutes.contractNotes,
    [EReportRoutes.subscriptionHistory]: reports + EReportRoutes.subscriptionHistory,
    [EReportRoutes.ledgerReport]: reports + EReportRoutes.ledgerReport,
    [EReportRoutes.dpBills]: reports + EReportRoutes.dpBills,
    [EReportRoutes.dpInterest]: reports + EReportRoutes.dpInterest,
    //margin will be added here in future
};
const betaLiveReportPaths = {
    /****************** As dashboard=upcoming & tax=dev-in-progress , we are showing existing ************************/
    [EReportRoutes.dashboard]: "/reports",
    [EReportRoutes.tax]: "/reports?reportName=Tax",
    /*************************** Existing Other reports , rebranded but also in live **********************************/
    [EReportRoutes.dpBills]: "/reports?reportName=otherReports&tab=dpbills",
    [EReportRoutes.contractNotes]: "/reports?reportName=otherReports&tab=contract-notes",
    [EReportRoutes.subscriptionHistory]: "/reports?reportName=otherReports&tab=subscription-history",
    [EReportRoutes.ledgerReport]: "/reports?reportName=otherReports&tab=ledger-report",
    [EReportRoutes.dpInterest]: "/reports?reportName=otherReports&tab=delayed-payment-interest",
    [EReportRoutes.transactionHistory]: "/reports?reportName=Transactions",
};
const selectedReportPaths = forBetalive
    ? betaLiveReportPaths
    : opClientReportPaths;
export const reportsRoutePaths = Object.assign({ 
    /*******orderbook => upcoming*******/
    [EReportRoutes.orderbook]: reports + EReportRoutes.orderbook, [EReportRoutes.holding]: reports + EReportRoutes.holding, [EReportRoutes.positions]: reports + EReportRoutes.positions, [EReportRoutes.profitandloss]: reports + EReportRoutes.profitandloss, [EReportRoutes.transactionHistory]: "/reports?reportName=Transactions", [EReportRoutes.marginReport]: "/reports?reportName=otherReports&tab=margin-report" }, selectedReportPaths);
export const mfQuoteRedirectionByCategory = (mfCategory) => {
    switch (mfCategory) {
        case "Other":
            return quotesRoutes.QIndex;
        default:
            return quotesRoutes.QMutual_Funds;
    }
};
